(() => {
  if (window.moveSmartFeraLoopReady) return;
  window.moveSmartFeraLoopReady = true;

  function init(root = document) {
    root.querySelectorAll('[data-msh-reviews]').forEach(mount => {
      if (mount.dataset.mshLoopReady) return;
      mount.dataset.mshLoopReady = 'true';

      let track;
      let reviewCards = [];
      let pauseButton;
      let observer;
      let frame;
      let lastFrame = 0;
      let loopDistance = 0;
      let position = 0;
      let hovered = false;
      let focused = false;
      let gesture;
      let suppressClickUntil = 0;
      let resumeAfter = 0;
      let paused = matchMedia('(prefers-reduced-motion: reduce)').matches || !!window.Shopify?.designMode;
      const wide = matchMedia('(min-width: 1200px)');
      const tablet = matchMedia('(min-width: 750px)');
      const motion = matchMedia('(prefers-reduced-motion: reduce)');

      const normalizeHeading = () => {
        mount.querySelectorAll('.fera-widget > h1').forEach(oldHeading => {
          const heading = document.createElement('h3');
          heading.className = 'msh__fera-heading';
          heading.textContent = oldHeading.textContent;
          oldHeading.replaceWith(heading);
        });
      };

      const navigationSelector = '.fera-testimonialCarousel-nav [data-fera-action="showPrev"], .fera-testimonialCarousel-nav [data-fera-action="showNext"]';
      const normalizeWidget = () => {
        mount.querySelectorAll(navigationSelector).forEach(button => {
          button.setAttribute('role', 'button');
          button.setAttribute('tabindex', '0');
          button.setAttribute('aria-label', button.dataset.feraAction === 'showPrev' ? 'Previous reviews' : 'Next reviews');
        });
        mount.querySelectorAll('.fera-customer-avatar-container img').forEach(image => {
          image.alt = '';
          if (!image.getAttribute('src') && image.dataset.src) image.src = image.dataset.src;
        });
      };

      const setPaused = next => {
        paused = next;
        mount.dataset.mshPaused = String(paused);
        if (pauseButton) {
          pauseButton.textContent = paused ? 'Play reviews' : 'Pause reviews';
          pauseButton.setAttribute('aria-pressed', String(paused));
        }
      };

      const sizeLoop = () => {
        if (!track || !reviewCards.length) return;
        const visibleCount = wide.matches ? 5 : (tablet.matches ? 3 : 1);
        const gap = parseFloat(getComputedStyle(track).columnGap) || 16;
        const viewportWidth = track.parentElement?.clientWidth || track.clientWidth;
        const cardWidth = Math.max(180, (viewportWidth - gap * (visibleCount - 1)) / visibleCount);
        track.style.setProperty('--msh-review-card-width', `${cardWidth}px`);
        const progress = loopDistance ? position / loopDistance : 0;
        loopDistance = reviewCards.length * (cardWidth + gap);
        position = progress * loopDistance;
      };

      const move = direction => {
        if (!track || !loopDistance) return;
        const step = loopDistance / reviewCards.length;
        const index = position / step;
        const nextIndex = direction > 0 ? Math.floor(index + 0.001) + 1 : Math.ceil(index - 0.001) - 1;
        position = ((nextIndex * step) % loopDistance + loopDistance) % loopDistance;
        track.style.setProperty('transform', `translate3d(${-position}px, 0, 0)`, 'important');
        resumeAfter = performance.now() + 3000;
      };

      const navigate = event => {
        if (event.type === 'click' && performance.now() < suppressClickUntil) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const button = event.target.closest(navigationSelector);
        if (!button || !track || !loopDistance) return;
        if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        event.stopImmediatePropagation();
        move(button.dataset.feraAction === 'showPrev' ? -1 : 1);
      };

      const pointerDown = event => {
        if (!event.isPrimary || event.button !== 0 || !event.target.closest('.fera-slider')
          || event.target.closest('a, button, input, select, textarea')) return;
        gesture = { id: event.pointerId, x: event.clientX, y: event.clientY };
      };
      const pointerEnd = event => {
        if (!gesture || event.pointerId !== gesture.id) return;
        const dx = event.clientX - gesture.x;
        const dy = event.clientY - gesture.y;
        gesture = null;
        if (event.type === 'pointerup' && Math.abs(dx) >= 40 && Math.abs(dx) > Math.abs(dy)) {
          suppressClickUntil = performance.now() + 350;
          move(dx < 0 ? 1 : -1);
        }
      };

      const setup = () => {
        normalizeHeading();
        normalizeWidget();
        if (mount.classList.contains('msh__fera--looping')) return;
        const available = [...mount.querySelectorAll('.fera-review:not(.glide__slide--clone):not(.msh__review-clone)')];
        if (!available.length) return;

        reviewCards = available.slice(0, 20);
        track = reviewCards[0].parentElement;
        available.forEach((card, index) => card.toggleAttribute('data-msh-loop-unused', index >= reviewCards.length));

        reviewCards.forEach(card => {
          card.setAttribute('data-msh-loop-source', '');
          card.style.removeProperty('order');
          card.removeAttribute('data-msh-visible');
          const clone = card.cloneNode(true);
          clone.classList.add('msh__review-clone');
          clone.removeAttribute('data-msh-loop-source');
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach(node => {
            node.setAttribute('tabindex', '-1');
          });
          clone.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
          track.append(clone);
        });

        const controls = document.createElement('div');
        controls.className = 'msh__review-loop-control';
        pauseButton = document.createElement('button');
        pauseButton.type = 'button';
        pauseButton.addEventListener('click', () => setPaused(!paused));
        const arrow = (label, symbol, direction) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.setAttribute('aria-label', label);
          button.textContent = symbol;
          button.addEventListener('click', () => move(direction));
          return button;
        };
        controls.append(
          arrow('Previous reviews', '\u2190', -1),
          pauseButton,
          arrow('Next reviews', '\u2192', 1)
        );
        mount.append(controls);

        mount.classList.add('msh__fera--looping');
        setPaused(paused);
        sizeLoop();

      };

      const resize = () => sizeLoop();
      const reduceMotion = () => setPaused(motion.matches || !!window.Shopify?.designMode);
      const enter = () => { hovered = true; };
      const leave = () => { hovered = false; };
      const focusIn = () => { focused = true; };
      const focusOut = event => {
        if (mount.contains(event.relatedTarget)) return;
        focused = false;
      };
      const tick = time => {
        if (track && loopDistance) {
          if (!lastFrame) lastFrame = time;
          if (!paused && !hovered && !focused && !gesture && time >= resumeAfter && !document.hidden && !motion.matches) {
            position = (position + (time - lastFrame) * 0.03) % loopDistance;
          }
          track.style.setProperty('transform', `translate3d(${-position}px, 0, 0)`, 'important');
          lastFrame = time;
        }
        frame = requestAnimationFrame(tick);
      };
      wide.addEventListener('change', resize);
      tablet.addEventListener('change', resize);
      motion.addEventListener('change', reduceMotion);
      window.addEventListener('resize', resize, { passive: true });
      mount.addEventListener('mouseenter', enter);
      mount.addEventListener('mouseleave', leave);
      mount.addEventListener('focusin', focusIn);
      mount.addEventListener('focusout', focusOut);
      mount.addEventListener('pointerdown', pointerDown, true);
      mount.addEventListener('click', navigate, true);
      mount.addEventListener('keydown', navigate, true);
      window.addEventListener('pointerup', pointerEnd);
      window.addEventListener('pointercancel', pointerEnd);

      observer = new MutationObserver(setup);
      observer.observe(mount, { childList: true, subtree: true });
      setup();
      frame = requestAnimationFrame(tick);

      mount._mshObserver = observer;
      mount._mshCleanup = () => {
        observer.disconnect();
        wide.removeEventListener('change', resize);
        tablet.removeEventListener('change', resize);
        motion.removeEventListener('change', reduceMotion);
        window.removeEventListener('resize', resize);
        mount.removeEventListener('mouseenter', enter);
        mount.removeEventListener('mouseleave', leave);
        mount.removeEventListener('focusin', focusIn);
        mount.removeEventListener('focusout', focusOut);
        mount.removeEventListener('pointerdown', pointerDown, true);
        mount.removeEventListener('click', navigate, true);
        mount.removeEventListener('keydown', navigate, true);
        window.removeEventListener('pointerup', pointerEnd);
        window.removeEventListener('pointercancel', pointerEnd);
        cancelAnimationFrame(frame);
      };
    });
  }

  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-msh-reviews]').forEach(mount => mount._mshCleanup?.());
  });
})();

